import { Theme } from '@mui/material/styles'

export const styles = {
  tarjeta: {
    borderBottom: 'solid 1px #ddd',
    padding: (theme: Theme) => theme.spacing(1),
  },

  count: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
  },

  date: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontFamily: 'Source Sans Pro',
    fontSize: '12px',
  },

  name: {
    color: '#005AA3',
    fontFamily: 'Source Sans Pro',
    fontSize: '14px',
  },

  status: {
    color: (theme: Theme) => theme.palette.text.primary,
    fontFamily: 'Source Sans Pro Italic',
    fontSize: '12px',
  },

  textButton: {
    paddingY: 0,
    marginLeft: (theme: Theme) => theme.spacing(-0.8),
  },

  total: {
    color: (theme: Theme) => theme.palette.primary.main,
    fontFamily: 'Source Sans Pro Semibold',
    fontSize: '14px',
  },
}
